import cn from 'classnames';
import { forwardRef } from 'react';

import type { ForwardedRef, ReactElement } from 'react';

import type { ModalFooterActionsProps } from './modal-footer-actions.types';

import './modal-footer-actions.scss';

/**
 * Modal footer actions component is used to render the actions section of the modal dialog footer.
 * You can use `ModalCloseButton` component to render the cancel button which is call `onClose` by default.
 */
const ModalFooterActions = forwardRef(
  (props: ModalFooterActionsProps, forwardedRef: ForwardedRef<HTMLDivElement>): ReactElement => {
    const { children, className, ...rest } = props;

    return (
      <div {...rest} className={cn('rbui-modal__footer--actions', className)} ref={forwardedRef}>
        {children}
      </div>
    );
  },
);

ModalFooterActions.displayName = 'ModalFooterActions';

export default ModalFooterActions;
